import * as actionCreators from '../state/actionCreators'
import { LogisticsState } from "../state/reducer"
import { useSelector } from "react-redux"
import { State } from "../../../state"
import { bindActionCreators } from "redux"
import { useDispatch } from "react-redux"

export const useLogisticsState = (): LogisticsState => useSelector((state: State) => state.logisticsReducer)

export const useLogisticsStateActions = () => bindActionCreators(actionCreators, useDispatch())
